import {notification} from "antd";

const NotificationService = {
    success: (msg, desc) => {
        notification.success({
            message: msg,
            description: desc,
            placement: 'bottomRight'
        })
    },
    error: (msg, desc) => {
        notification.error({
            message: msg,
            description: desc,
            placement: 'bottomRight'
        })
    },
    info: (msg, desc) => {
        notification.info({
            message: msg,
            description: desc,
            placement: 'bottomRight'
        })
    }
}

export default NotificationService